// Generated by tools/design-tokens from design/figma. Do not edit.

export type DrawingPart =
  | {
      /** Path data in the vector's own box, at (x, y) in the drawing. */
      d: string;
      x: number;
      y: number;
      stroke: string;
      width: number;
    }
  | { ellipse: true; x: number; y: number; w: number; h: number; fill: string };

/** The sample drawing's box, in canvas pixels. */
export const TURTLE_SIZE = { width: 480, height: 320 } as const;

/** Sample / Turtle drawing, stage by stage. */
export const turtle = {
  Outline: [
    { d: 'M5 101C5 -27 225 -27 225 101H5Z', x: 105, y: 119, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 134.46, y: 216.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 272.46, y: 216.51, stroke: '#3e8e5e', width: 10 },
  ],
  Head: [
    { d: 'M5 101C5 -27 225 -27 225 101H5Z', x: 105, y: 119, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 134.46, y: 216.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 272.46, y: 216.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 5H21', x: 325, y: 201, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 35C5 18.4 18.4 5 35 5C51.6 5 65 18.4 65 35C65 51.6 51.6 65 35 65C18.4 65 5 51.6 5 35Z', x: 339, y: 161, stroke: '#3e8e5e', width: 10 },
  ],
  Done: [
    { d: 'M2 4.887C66 -5.113 126 14.887 186 4.887C246 -5.113 306 14.887 370 4.887', x: 54, y: 270.995, stroke: '#8a8c82', width: 4 },
    { d: 'M5 101C5 -27 225 -27 225 101H5Z', x: 105, y: 119, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 134.46, y: 216.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M5.085 5C3.085 45 37.085 47 37.085 7', x: 272.46, y: 216.51, stroke: '#3e8e5e', width: 10 },
    { d: 'M35.001 5.001L5.001 21.001', x: 75, y: 209, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 5H21', x: 325, y: 201, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 35C5 18.4 18.4 5 35 5C51.6 5 65 18.4 65 35C65 51.6 51.6 65 35 65C18.4 65 5 51.6 5 35Z', x: 339, y: 161, stroke: '#3e8e5e', width: 10 },
    { d: 'M5 21L39 5L73 21V61L39 77L5 61V21Z', x: 181, y: 129, stroke: '#8a5a3b', width: 10 },
    { d: 'M37.037 16L21.037 4M105.037 56L139.037 82M37.037 56L3.037 82M105.037 16L121.037 4', x: 148.5, y: 134, stroke: '#8a5a3b', width: 10 },
    { d: 'M2 4C8 10.001 16 8 18 2', x: 382, y: 205.81, stroke: '#282b25', width: 4 },
    { ellipse: true, x: 377, y: 181, w: 10, h: 10, fill: 'var(--zumpo-ink)' },
  ],
} as const satisfies Record<string, readonly DrawingPart[]>;
